export default __webpack_public_path__ + "static/media/3.2b9bd56c.jpg";